import {
    type DataGridCellProps,
    useCellControlTabIndex,
} from "@design-system/DataGrid";
import { HStack } from "@design-system/HStack/HStack";
import { TaskBlockedBadge } from "../../TaskBlockedBadge/TaskBlockedBadge";
import { getBlockedByLabel } from "../../taskBlockers";
import { useTaskListOpenTask } from "../../taskList.context";
import type { NestedTaskRow } from "../../types";
import { useOpenTaskSection } from "../../useOpenTaskSection";
import { TaskRowPresence } from "./TaskRowPresence";
import { hasTaskFields, type TaskListTaskRow } from "./taskRowCells";

const BlockedBadge = ({ task }: { task: TaskListTaskRow }) => {
    const openTask = useTaskListOpenTask();
    const openTaskDependencies = useOpenTaskSection(openTask, "dependencies");
    const tabIndex = useCellControlTabIndex();

    return (
        <TaskBlockedBadge
            label={getBlockedByLabel(task)}
            tabIndex={tabIndex}
            onClick={() => openTaskDependencies(task)}
        />
    );
};

/**
 * After a task's title: the blocked badge (opens Dependencies) and its
 * presence stack. Nothing on draft rows.
 */
export const TaskTitleExtras = ({
    context,
}: DataGridCellProps<NestedTaskRow>) => {
    const task = context.row.original;
    if (!hasTaskFields(task) || task.isNewPlaceholder) {
        return null;
    }
    const hasBlockers = (task.numberOfActiveBlockedByTasks ?? 0) > 0;
    return (
        <HStack as="span" gap={4} align="center">
            {hasBlockers ? <BlockedBadge task={task} /> : null}
            <TaskRowPresence task={task} />
        </HStack>
    );
};
